function getToken() {
    return localStorage.getItem("token");
}

export function headers() {
    // console.log(getToken())
    return {
        Authorization: `Bearer ${getToken()}`,
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    }
}